export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'movie',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '最新最热的电影大片，涵盖科幻、动作、喜剧、悬疑等多种类型，高清画质流畅播放',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热门电视剧大全，古装、都市、悬疑、甜宠等各类剧集持续更新，追剧不等待',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-live-line',
    description: '丰富多彩的综艺节目，音乐竞技、真人秀、脱口秀、旅行综艺，欢乐不停歇',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '国漫崛起之作，热血战斗、修仙玄幻、搞笑日常，精品动画番剧一网打尽',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    icon: 'ri-earth-line',
    description: '高质量纪录片频道，自然探秘、人文历史、科技前沿、美食旅行，打开认知新世界',
  },
];

export const categoryMap: Record<string, string> = {
  '电影': 'movie',
  '电视剧': 'tv',
  '综艺': 'variety',
  '动漫': 'anime',
  '纪录片': 'documentary',
};

export const slugToCategory: Record<string, string> = {
  'movie': '电影',
  'tv': '电视剧',
  'variety': '综艺',
  'anime': '动漫',
  'documentary': '纪录片',
};